import { ChakraProvider, defaultSystem } from '@chakra-ui/react';
import { ThemeProvider } from 'next-themes';
import React from 'react';

type ProviderProps = {
  children: React.ReactNode;
};

export function Provider({ children }: ProviderProps): React.JSX.Element {
  return (
    <ThemeProvider attribute="class" forcedTheme="light" enableSystem={false}>
      <ChakraProvider value={defaultSystem}>{children}</ChakraProvider>
    </ThemeProvider>
  );
}

export default Provider;
